import { ETaxStatus } from "../../types/e-tax.type";

export const STATUS_COLOR: Record<ETaxStatus, string> = {
  IN_PROGRESS: "#5C69E8",
  COMPLETED: "#45BE77",
  PARTIALLY_COMPLETED: "#FDA42C",
  FAILED: "#FB3B3B",
};

/**
 * What a send run's headline says.
 *
 * These used to be "รอตรวจสอบ / สำเร็จ / กำลังประมวลผล / ล้มเหลว", which described nothing
 * a reader could act on. "รอตรวจสอบ" sounded like an internal review step of ours, when what
 * it actually means is that we have handed the documents to the filing agent and heard
 * nothing back — the state 823 production documents have been sitting in, some for two
 * weeks. And "สำเร็จ" was the worst of them: it reads as "filed", while it only ever meant
 * the agent acknowledged the document. Filing with the Revenue Department happens later,
 * by the 10th of the following month, and conflating the two is the most expensive
 * misunderstanding available on this screen.
 */
export const STATUS_LABEL: Record<ETaxStatus, string> = {
  IN_PROGRESS: "รอตัวแทนนำส่งยืนยัน",
  COMPLETED: "ตัวแทนนำส่งได้รับแล้ว",
  PARTIALLY_COMPLETED: "สำเร็จบางส่วน",
  FAILED: "ส่งไม่สำเร็จ",
};
